import React from 'react';
import { FlatList, TouchableOpacity, View, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import { CarouselItem, CarouselItemPlaceHolder } from '@double_point/rn-components';
import FloatingVenueSelectorButtons from './FloatingVenueSelectorButtons';
import Venue from 'types/models/Venue';
import VenueListProps from 'types/components/VenueListProps';
import VenueImageTypes from 'types/enums/VenueImageTypes';
import useChangeVenue from 'hooks/useChangeVenue';
import AppContext from 'contexts/AppContext';
import App from 'constants/App';
import { styles } from 'styles/components/venueList';
import { greenColor } from 'styles/global';

export default ({ venues, navigation, reachedEndOfList, setReachedEndOfList }: VenueListProps): JSX.Element => {
  const { t } = useTranslation();
  const { currentVenue } = React.useContext(AppContext);
  const { selectedVenue, setSelectedVenue } = useChangeVenue();

  React.useEffect(() => {
    return () => {
      setReachedEndOfList(false);
    };
  }, [reachedEndOfList]);

  const renderItem = ({ item }: any) => {
    return (
      <TouchableOpacity
        key={item.id}
        style={{ outlineStyle: 'none' }}
        onPress={() => {
          if (item.id !== -1) {
            // Si el venue que se selecciona es igual a venue que se había seleccionado antes
            // selectedVenue` se setea null
            item.id !== selectedVenue?.id ? setSelectedVenue(item) : setSelectedVenue(null);
          }
        }}
      >
        {item.id !== -1 ? (
          <CarouselItem
            id={item.id}
            image={
              item.images.find((image: any) => image.venueImageId === VenueImageTypes.logo)?.path ?? App.defaultImage
            }
            description={item.name}
            textColor={currentVenue ? '#FFF' : greenColor}
            isSelected={item.id === selectedVenue?.id}
          />
        ) : (
          <CarouselItemPlaceHolder />
        )}
      </TouchableOpacity>
    );
  };

  // Placeholders para completar 3 columns
  let data: any[];
  if (venues.length > 0 && venues.length < 3) {
    data = [...venues];
    while (data.length < 3) {
      data.push({ id: -1 });
    }
  } else {
    data = venues;
  }

  const renderList = () => {
    return (
      <>
        <View style={styles.flatlistContainer}>
          <FlatList
            data={data}
            renderItem={renderItem}
            keyExtractor={(item: Venue) => item.id}
            numColumns={3}
            columnWrapperStyle={{ justifyContent: 'space-around' }}
          />
        </View>

        {reachedEndOfList ? (
          <FloatingVenueSelectorButtons navigation={navigation} listReachedItsEnd={reachedEndOfList} />
        ) : (
          <View style={styles.dummyBottomContainer} />
        )}
      </>
    );
  };

  return <>{venues.length > 0 ? renderList() : <Text style={styles.noVenues}>{t('no-venues-available')}</Text>}</>;
};
